import { BellOutlined, MailOutlined } from "@ant-design/icons";
import { Button, Col, Flex, Row, Typography } from "antd";
import Layout, { Content } from "antd/es/layout/layout";
import React from "react";
import "./index.scss";
import { useAuth } from "../../Context/AuthContext/Index";
import useOrganization from "../../Hooks/useOrganization";
import { Link, NavLink, useNavigate } from "react-router-dom";

const NoJobPositions = () => {
  const navigate = useNavigate();
  const { isUserLoggedIn } = useAuth();
  const { organization } = useOrganization();

  return (
    <>
      {!organization ? (
        <Layout
          style={{
            height: "100vh",
            display: "flex",
            alignContent: "center",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Flex align="center" justify="center" vertical>
            <BellOutlined style={{ fontSize: "32px" }} />
            <Typography.Title level={4} className="message">
              There seems to be an error with the link, please check and retry.
            </Typography.Title>
            <Typography className="message-subtext">
              QualifyMe is an AI based hiring assistant. If you would like to
              use it for your company,
              <NavLink to={"https://qualifyme.ai"}> Please click</NavLink>
            </Typography>
            {/* <Button
              style={{ margin: "32px" }}
              type="primary"
              onClick={() => navigate("/sign-up")}
            >
              Sign Up
            </Button> */}
          </Flex>
        </Layout>
      ) : (
        <>
          {isUserLoggedIn ? (
            <Layout className="no_job_positions_container">
              <Content className="no_job_positions">
                <Flex align="center" justify="center" vertical>
                  <BellOutlined style={{ fontSize: "50px" }} />
                  <Typography className="message">
                    Thank you for your interest
                    {organization ? " in " + organization?.orgName : ""}. We
                    dont have any openings at the moment.
                  </Typography>
                  <Typography className="message-subtext">
                    We will notify you when there is an available position.
                  </Typography>
                </Flex>
              </Content>
            </Layout>
          ) : (
            <Layout className="no_job_positions_container">
              <Content className="no_job_positions">
                <Flex align="center" justify="center" vertical>
                  <MailOutlined style={{ fontSize: "50px" }} />
                  <Typography className="message">
                    Thank you for your interest
                    {organization ? " in " + organization?.orgName : ""}. We
                    dont have any openings at the moment.
                  </Typography>
                  <Typography className="message-subtext">
                    Please sign up and we will notify you when there is an
                    available position.
                  </Typography>
                  <Button
                    type="primary"
                    onClick={() => {
                      navigate(`/sign-up`);
                    }}
                  >
                    Sign Up
                  </Button>
                </Flex>
              </Content>
            </Layout>
          )}
        </>
      )}
    </>
  );
};

export default NoJobPositions;
